module.exports = __webpack_public_path__ + "static/media/Question_icon_2.4b3574f1.svg";